import { useUserData } from "@/hooks/useUserData"
import { UserData } from "@/lib/fetch-users"

type UserWrapperProps = {
  userName: string | null | undefined
  returnMissingUser?: boolean
  render: (user: UserData) => React.JSX.Element
}

const UserProvider = ({ userName, returnMissingUser, render }: UserWrapperProps) => {
  const user = useUserData(userName, returnMissingUser)

  if (!user) {
    return null
  }

  return render(user)
}

export { UserProvider }
